"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isNum = function isNum(v) {
  return typeof v === 'number';
};

exports.isPoint = function (point) {
  return point.x !== undefined && point.y !== undefined;
};

exports.isPoint3D = function (point) {
  return point.z !== undefined;
};

var toDecimal = function toDecimal(num, precision) {
  if (precision === void 0) {
    precision = 2;
  }

  precision = Math.pow(10, precision);
  return Math.round(num * precision) / precision;
};

var ZERO_POINT = {
  x: 0,
  y: 0,
  z: 0
};

var distance1D = function distance1D(a, b) {
  return Math.abs(a - b);
};

exports.angle = function (a, b) {
  if (b === void 0) {
    b = ZERO_POINT;
  }

  return exports.radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
};

exports.degreesToRadians = function (degrees) {
  return degrees * Math.PI / 180;
};

exports.dilate = function (a, b, dilation) {
  return a + (b - a) * dilation;
};

exports.distance = function (a, b) {
  if (b === void 0) {
    b = ZERO_POINT;
  }

  if (isNum(a) && isNum(b)) {
    return distance1D(a, b);
  } else if (exports.isPoint(a) && exports.isPoint(b)) {
    var xDelta = distance1D(a.x, b.x);
    var yDelta = distance1D(a.y, b.y);
    var zDelta = exports.isPoint3D(a) && exports.isPoint3D(b) ? distance1D(a.z, b.z) : 0;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
  }

  return 0;
};

exports.getProgressFromValue = function (from, to, value) {
  return (value - from) / (to - from);
};

exports.getValueFromProgress = function (from, to, progress) {
  return -progress * from + progress * to + from;
};

exports.pointFromAngleAndDistance = function (origin, angle, distance) {
  angle = exports.degreesToRadians(angle);
  return {
    x: distance * Math.cos(angle) + origin.x,
    y: distance * Math.sin(angle) + origin.y
  };
};

exports.radiansToDegrees = function (radians) {
  return radians * 180 / Math.PI;
};

exports.smooth = function (newValue, oldValue, duration, smoothing) {
  if (smoothing === void 0) {
    smoothing = 0;
  }

  return toDecimal(oldValue + duration * (newValue - oldValue) / Math.max(smoothing, duration));
};

exports.speedPerFrame = function (xps, frameDuration) {
  return isNum(xps) ? xps / (1000 / frameDuration) : 0;
};

exports.speedPerSecond = function (velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
};

exports.stepProgress = function (steps, progress) {
  var segment = 1 / (steps - 1);
  var target = 1 - 1 / steps;
  var progressOfTarget = Math.min(progress / target, 1);
  return Math.floor(progressOfTarget / segment) * segment;
};